export default "__VITE_ASSET__DkNKMCIc__"